export * from './LegalPage';
export * from './LegalPageContentful';
